import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from '../../components/other/card/card'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import TextArea from 'antd/es/input/TextArea'
import Loader from '../pages/loader'
import { Select } from 'antd'
import { useMarkUgcEpisodeMutation } from '../../redux/apis/linkManagement/ugc/lMUgcEpisodeApiSlice'
import InsertionResultModal from '../../components/InsertionResultModal'

const UgcEpisodeMarking = React.memo(() => {
  const context = useContext(AppSettings)
  const [create, { isLoading }] = useMarkUgcEpisodeMutation()
  const [result, setResult] = useState(null)

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      urls: '',
      status: ''
    },

    validationSchema: Yup.object({
      urls: Yup.string().required('Please Enter Urls'),
      status: Yup.string().required('Please Enter Report Status')
    }),

    onSubmit: async values => {
      const urls = values.urls
        .split('\n')
        .map(url => url.trim())
        .filter(url => url)

      const data = urls.map(url => ({
        url,
        status: values.status
      }))

      try {
        const res = await create(data)
        const resultData = res?.data ?? res?.error?.data ?? {}
        setResult(resultData)
        if (res?.data?.success) {
          validation.resetForm()
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div>
      <Loader isLoading={isLoading} />
      <InsertionResultModal
        result={result}
        reportTitle='UGC Episode URL marking'
        onClose={() => setResult(null)}
      />
      <Card>
        <CardHeader>
          <p>UGC Episode Link Marking</p>
        </CardHeader>
        <CardBody>
          <div className='mb-3'>
            <label className='form-label'>Report Status</label>
            <br />
            <Select
              name='status'
              className='customSelect'
              style={{ width: '100%' }}
              onBlur={validation.handleBlur}
              onChange={e => validation.setFieldValue('status', e)}
              value={validation.values?.status}
              options={[
                { label: 'Related', value: 'related' },
                { label: 'UnRelated', value: 'unrelated' },
              ]}
            />
            {validation.touched.status && validation.errors.status ? (
              <p className='text-danger'>{validation.errors.status}</p>
            ) : null}
          </div>
          <div className='mb-3 flex-1 customInput'>
            <label className='form-label'>URLs (separated by new lines)</label>
            <TextArea
              type='text'
              name='urls'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.urls}
              placeholder={`Enter urls separated by new lines\nexample:\ntest.com\ntest2.com\ntest3.com`}
              rows={15}
            />
            {validation.touched.urls && validation.errors.urls ? (
              <p className='text-danger'>{validation.errors.urls}</p>
            ) : null}
          </div>
        </CardBody>
        <CardFooter>
          <div className='flex justify-end gap-8'>
            <button
              onClick={() => validation.handleSubmit()}
              className='btn btn-theme'
            >
              Submit
            </button>
          </div>
        </CardFooter>
      </Card>
    </div>
  )
})

UgcEpisodeMarking.displayName = 'UgcEpisodeMarking'

export default UgcEpisodeMarking
